// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialClassPromotionState,
    ClassPromotionSchema,
    ClassPromotionFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const ClassPromotion = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [class_promotion, setClassPromotion] = useState(InitialClassPromotionState);
    const [formFields, setFormFields] = useState(ClassPromotionFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getClasses = async () => {
        spinService.on();
        const response = await get(EntityConstants.GRADES, "max=all");
        const data = await response.json();
        attachOptions("old_class_id", data);
        attachOptions("new_class_id", data);
        spinService.off();
    };

    const handleAcademicYearChange = async () => {
        spinService.on();
        const response = await get(EntityConstants.ACADEMIC_YEARS, "max=all");
        const data = await response.json();
        attachOptions("academic_year_id", data);
        spinService.off();
    };

    const getSchoolsByCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("schools", data);
        spinService.off();
    };

    const getClassPromotion = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.CLASS_PROMOTIONS + `/${id}`);
        const data = await response.json();
        setClassPromotion(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewClassPromotion = values.id === undefined;
        const url = EntityConstants.PROMOTING
        const method = isNewClassPromotion ? post : put;
        const response = await method(url, { class_promotion: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(MessageContants.CLASS_PROMOTION_EXECUTED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getClasses();
        handleAcademicYearChange();
        getSchoolsByCompanies();
        if (id !== undefined) {
            getClassPromotion(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={class_promotion}
            validationSchema={ClassPromotionSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.CLASS_PROMOTION_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.CLASS_PROMOTION_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    Execute
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

ClassPromotion.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default ClassPromotion;
